module.exports = __webpack_public_path__ + "img/pad.fca1e968.png";